import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

/**
 * スタディグループのナビゲーションを処理するカスタムフック
 * スタディグループの情報を更新し、対応するストリームページに遷移します
 */
export const useStudyGroupNavigation = () => {
  const navigate = useNavigate();

  const navigateToStudyGroup = useCallback(
    (studyGroupId: number) => {
      requestAnimationFrame(() => {
        try {
          navigate({
            to: "/study-group/$study-group-id/stream",
            params: { "study-group-id": String(studyGroupId) },
            replace: false,
          });
        } catch (error) {
          console.error("❌ Navigation error:", error);
        }
      });
    },
    [navigate],
  );

  return { navigateToStudyGroup };
};
